"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeedService = void 0;
const environment_1 = require("../../constants/environment");
const environment_enum_1 = require("../enum/environment.enum");
const axios_1 = __importDefault(require("axios"));
class FeedService {
    constructor(ENV = environment_enum_1.ENVIRONMENT.DEV, key) {
        this.RESOURCE = 'feed';
        this.getUserFeeds = async (user) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/user/${user.person_id}/feed?ou=${user.company_id}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.key } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getFeed = async (id) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/entry/${id}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.key } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.encryptData = async (studentData) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/arcfour`;
            const response = await axios_1.default.post(URL, JSON.stringify(studentData), { headers: { 'x-api-key': this.key } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getOperatingUnits = async () => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/company/campus`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.key } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.createFeed = async (body) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/entry`;
            const response = await axios_1.default.post(URL, JSON.stringify(body), { headers: { 'x-api-key': this.key } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        //NO REGRESA NADA EL DELETE
        this.DeleteFeed = async (id) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/entry/${id}`;
            const response = await axios_1.default.delete(URL, { headers: { 'x-api-key': this.key } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        //NO REGRESA NADA EL PUT
        this.updateFeed = async (id, body) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/entry/${id}`;
            const response = await axios_1.default.put(URL, JSON.stringify(body), { headers: { 'x-api-key': this.key } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        //Este GET no regresa nada en este servicio y no lo encuentro implementado en POINT--------------
        this.getFullFeeds = async (user) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/{company}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.key } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        //ESTE SERVICIO NO ESTA IMPLEMENTADO EN POINT NO SE QUE MANDA NI QUE TRAE---------------
        this.createReaction = async (body) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/reaction`;
            const response = await axios_1.default.post(URL, JSON.stringify(body), { headers: { 'x-api-key': this.key } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        //Este GET no regresa nada en este servicio y no lo encuentro implementado en POINT-------------
        this.getFeedPage = async (page) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/${page}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.key } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        //PREGUNTAR ELEAZAR GET NO ENCUENTRO SENTIDO EN LAMBDA Y NO SE USA EN POINT ESTO-----------
        this.getCompanyFeed = async (company) => {
            var URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}`;
            if (company)
                URL += `/${company}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.key } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.ENV = ENV;
        this.key = key;
    }
    /** No Funcional for now
     * Retriveas all **Feeds** with specified filter
     * @param userId **Type:** `number` `required` User identified , test use userId = 4084
     * @param page **Type:** `number` Page number **value default:** 1
     * @param size **Type:** `number` Page size **value default:** 10
     * @param orderby **Type:** `string` Page order **value default:** date  **options*:* ['id','name','date']
     * @param filters **Type:** `object` Others filter **example:** filters= [{type:'Blogs'}]
     * @returns **Type:** `object` **example:** {data:[],
                                                "currentPage": 1,
                                                "pageSize": 2,
                                                "totalCount": 2,
                                                "totalPages": 1}
     */
    async getAllByUserId(userId, page = 1, size = 10, orderby, filters = []) {
        let url = `${environment_1.API_URL_BASE}/${this.ENV}/user/${userId}/feed`;
        for (let items of filters) {
            let filter = items;
            for (const key in filter) {
                let keyFilter = key;
                url += `&${key}=${filter[keyFilter]}`;
            }
        }
        const requestOptions = {
            method: 'GET',
            headers: {
                'x-api-key': this.key
            },
        };
        let response = {
            statusCode: 200,
            message: 'successlful',
            userMessage: '',
            data: [],
            currentPage: page,
            pageSize: size,
            totalCount: 2,
            totalPages: 1
        };
        try {
            const responseApiGateway = await fetch(url, requestOptions);
            const dataApi = await responseApiGateway.json();
            response.data = dataApi;
            response.totalCount = dataApi.length;
        }
        catch (e) {
            response.statusCode = 500;
            response.message = e.message;
        }
        return response;
    }
}
exports.FeedService = FeedService;
